export default __webpack_public_path__ + "static/media/post-06-detail.5c4f15c7.jpg";